import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from './Icon';
import { smoothScrollTo } from '../hooks';

export function FinalCTA() {
  const [cur, setCur] = useState<'USD' | 'INR'>('USD');
  const price = cur === 'USD' ? 'from $49/mo + usage' : 'from ₹3,999/mo + usage';

  return (
    <section className="py-24">
      <div className="mx-auto w-full max-w-[1180px] px-7">
        <div className="final-cta reveal">
          <span className="lp-eyebrow" style={{ background: 'rgba(255,255,255,.12)', color: '#ffd9b3', border: '1px solid rgba(255,255,255,.2)' }}>
            <Icon name="sparkles" size={13} /> Get started in minutes
          </span>
          <h2 style={{ marginTop: 18 }}>Try 50 AI calls free.<br />No coding required.</h2>
          <p>Hear the value before you pay a cent. Paste your store, generate a script, and watch CallXcel recover your first cart.</p>

          <div className="cur-toggle">
            <button className={cur === 'USD' ? 'on' : ''} onClick={() => setCur('USD')}>USD $</button>
            <button className={cur === 'INR' ? 'on' : ''} onClick={() => setCur('INR')}>INR ₹</button>
          </div>
          <div style={{ marginTop: 12 }}>
            <span className="offer-pill">
              <Icon name="zap" size={14} color="var(--orange-400)" />
              Free trial: <b>50 free calls</b> · then Growth <b>{price}</b>
            </span>
          </div>

          <div className="lp-hero-cta">
            <Link className="lp-btn lp-btn-orange lp-btn-lg" to="/app">
              Start free <Icon name="arrow-right" size={17} />
            </Link>
            <button
              className="lp-btn lp-btn-lg"
              style={{ background: 'rgba(255,255,255,.1)', color: '#fff', border: '1px solid rgba(255,255,255,.22)' }}
              onClick={() => smoothScrollTo('use-cases')}
            >
              Explore use cases
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
